import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  message: null,
};

export const addRoleSlice = createSlice({
  name: "addRole",
  initialState,
  reducers: {
    addRoleRequested: (state) => {
      state.status = "loading";
      state.error = null;
      state.message = null;
    },
    addRoleRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    addRoleRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.message = action.payload;
    },
  },
});

export const {
  addRoleRequested,
  addRoleRequestFailed,
  addRoleRequestSucceeded,
} = addRoleSlice.actions;

export default addRoleSlice.reducer;
